import { createElement } from "react";
import {
  textClassName,
  textWeightRegularClassName,
  textWeightMediumClassName,
} from "./text.style";
import { classes } from "typestyle";

interface TextProps {
  tagName?: 'span' | 'p' | 'div';
  weight?: 'regular' | 'medium';
  children?: React.ReactNode;
}

const Text: React.FC<TextProps> = ({
  tagName = 'span',
  weight = 'regular',
  children
}) => createElement(
  tagName,
  {
    className: classes(
      textClassName,
      (() => {
        switch (weight) {
          case 'regular':
            return textWeightRegularClassName;
          case 'medium':
            return textWeightMediumClassName;
        }
      })()
    ),
  },
  children
);

export default Text;
